module.exports = "./images/56@2x.png?63f0c5231fc268de5b82dad56dde7bf5";


//////////////////
// WEBPACK FOOTER
// ./src/images/56@2x.png
// module id = 45
// module chunks = 0